import styles from './Section.module.css';
import {useState} from 'react'

export default function Section(props){
  const [isOpen, setIsOpen] = useState(props.open);


  let bodyClasses = styles.body;
  bodyClasses += isOpen ? " " + styles.open : "";

  let arrowClasses = styles.arrow;
  arrowClasses += isOpen ? " " + styles.open : "";

  return (<section className={styles.section}>
    <div className={styles.header} style={{backgroundColor: props.bgColor}} >
      <div className={styles.number}><img src={props.numberImg} alt="Section number image" /></div>
      <div className={styles.summary}>
        <h2>{props.title}</h2>
        <p dangerouslySetInnerHTML={{__html: props.description}}></p>

      </div>
      <div className={styles.openBtn} style={{backgroundColor: props.darkColor}} onClick={()=>setIsOpen(!isOpen)}>
        <div className={arrowClasses}>
        </div>
      </div>

    </div>
    <div className={bodyClasses}>
      {props.children}
    </div>



    </section>);
}
